function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { memo, useCallback, useMemo } from 'react';
import { useRefCallback, useToggle } from '@bydesign-ui/hooks';
import { classnames, pascalCase } from '@bydesign-ui/utils';
import { useLocale, usePrefixCls } from '@byte-design/config';
import { RcPopper } from '../../../hooks/popper';
import { useMultipleDate } from '../../../hooks/date';
import { DateContentRender } from '../layout/DateContentRender';
import { MultiplePopperWrapper } from '../layout/MultiplePopperWrapper';
export function updateMultiplePanelDate(sd, newVal) {
  sd.getPanel('date').updateDate(newVal[newVal.length - 1] || new Date(), true);
}
export function withMultipleDate(type, panelType) {
  var func = memo(function (props) {
    var _usePrefixCls;

    var locale = useLocale('date');
    var datePicker = useLocale('date-picker.placeholder');

    var domRef = props.domRef,
        format = props.format,
        offset = props.offset,
        _props$value = props.value,
        value = _props$value === void 0 ? [] : _props$value,
        _props$invalid = props.invalid,
        invalid = _props$invalid === void 0 ? false : _props$invalid,
        onChange = props.onChange,
        onValueChange = props.onValueChange,
        outRangeDisabled = props.outRangeDisabled,
        _props$disabled = props.disabled,
        disabled = _props$disabled === void 0 ? false : _props$disabled,
        isDateDisabled = props.isDateDisabled,
        isMonthDisabled = props.isMonthDisabled,
        isYearDisabled = props.isYearDisabled,
        _props$startDay = props.startDay,
        startDay = _props$startDay === void 0 ? locale.startDay : _props$startDay,
        enableDragMask = props.enableDragMask,
        _props$dragMaskSelect = props.dragMaskSelectType,
        dragMaskSelectType = _props$dragMaskSelect === void 0 ? 'cover' : _props$dragMaskSelect,
        _props$enableDragMask = props.enableDragMaskReverseMode,
        enableDragMaskReverseMode = _props$enableDragMask === void 0 ? false : _props$enableDragMask,
        className = props.className,
        _props$size = props.size,
        size = _props$size === void 0 ? 'md' : _props$size,
        placement = props.placement,
        _props$placeholder = props.placeholder,
        placeholder = _props$placeholder === void 0 ? datePicker : _props$placeholder,
        _props$presets = props.presets,
        presets = _props$presets === void 0 ? [] : _props$presets,
        _props$clearable = props.clearable,
        clearable = _props$clearable === void 0 ? false : _props$clearable,
        width = props.width,
        propsStyle = props.style,
        popoverClassName = props.popoverClassName,
        popoverWrapperClassName = props.popoverWrapperClassName,
        filled = props.filled,
        extra = _objectWithoutProperties(props, ["domRef", "format", "offset", "value", "invalid", "onChange", "onValueChange", "outRangeDisabled", "disabled", "isDateDisabled", "isMonthDisabled", "isYearDisabled", "startDay", "enableDragMask", "dragMaskSelectType", "enableDragMaskReverseMode", "className", "size", "placement", "placeholder", "presets", "clearable", "width", "style", "popoverClassName", "popoverWrapperClassName", "filled"]);

    var parts = useMemo(function () {
      return ['date'];
    }, []);
    var onChangeCallback = useRefCallback(onChange);
    var onValueChangeCallback = useRefCallback(onValueChange);
    var handleChange = useCallback(function (val) {
      onChangeCallback(val);
      onValueChangeCallback(val);
    }, []);

    var _useMultipleDate = useMultipleDate({
      locale: _objectSpread(_objectSpread({}, locale), {}, {
        startDay: startDay
      }),
      disabled: disabled,
      format: format,
      offset: offset,
      value: value,
      onChange: handleChange,
      outRangeDisabled: outRangeDisabled,
      isDateDisabled: isDateDisabled,
      isMonthDisabled: isMonthDisabled,
      isYearDisabled: isYearDisabled,
      onUpdatePanelDate: updateMultiplePanelDate,
      startDay: startDay,
      parts: parts,
      panelType: panelType
    }),
        root = _useMultipleDate.root,
        onSetPreset = _useMultipleDate.onSetPreset,
        onSetPresetTrying = _useMultipleDate.onSetPresetTrying,
        onCancelPresetTrying = _useMultipleDate.onCancelPresetTrying;

    var style = useMemo(function () {
      return _objectSpread(_objectSpread({}, propsStyle), {}, {
        width: width !== undefined ? "".concat(width, "px") : undefined
      });
    }, [width, propsStyle]);
    var cls = classnames(usePrefixCls('date-' + type, (_usePrefixCls = {}, _defineProperty(_usePrefixCls, panelType, true), _defineProperty(_usePrefixCls, "multiple", true), _defineProperty(_usePrefixCls, "size", size), _usePrefixCls)), className);
    var popperCls = usePrefixCls('date-picker-popper');

    var _useToggle = useToggle(false),
        _useToggle2 = _slicedToArray(_useToggle, 3),
        show = _useToggle2[0],
        handleShow = _useToggle2[1],
        handleHide = _useToggle2[2];

    var handleClear = useCallback(function () {
      onChangeCallback([]);
      onValueChangeCallback([]);
    }, []);
    var handleCloseItem = useCallback(function (value) {
      onChangeCallback(value);
      onValueChangeCallback(value);
    }, []);
    var onResetPanel = useCallback(function () {
      root.repaintPanel();
    }, []);
    var wrapperData = useMemo(function () {
      return value.map(function (item) {
        return {
          label: item,
          value: item
        };
      });
    }, [value]);

    if (type === 'panel') {
      return React.createElement(DateContentRender, Object.assign({}, extra, {
        className: cls,
        style: style,
        parts: parts,
        root: root,
        enableDragMask: enableDragMask,
        dragMaskSelectType: dragMaskSelectType,
        enableDragMaskReverseMode: enableDragMaskReverseMode,
        presets: presets,
        onResetPanel: onResetPanel,
        onPresetItemClick: onSetPreset,
        onPresetItemMouseEnter: onSetPresetTrying,
        onPresetItemMouseLeave: onCancelPresetTrying
      }));
    }

    return React.createElement("div", Object.assign({}, extra, {
      className: cls,
      style: style,
      ref: domRef
    }), React.createElement(RcPopper, null, React.createElement(MultiplePopperWrapper, {
      invalid: invalid,
      show: show,
      placement: placement,
      placeholder: placeholder,
      size: size,
      clearable: clearable,
      onShow: handleShow,
      onHide: handleHide,
      datasource: wrapperData,
      disabled: disabled,
      width: width,
      onCloseItem: handleCloseItem,
      onClear: handleClear,
      className: popoverClassName,
      wrapperClassName: popoverWrapperClassName,
      filled: filled
    }, React.createElement(DateContentRender, {
      className: popperCls,
      parts: parts,
      root: root,
      onResetPanel: onResetPanel,
      presets: presets,
      enableDragMask: enableDragMask,
      enableDragMaskReverseMode: enableDragMaskReverseMode,
      dragMaskSelectType: dragMaskSelectType,
      onPresetItemClick: onSetPreset,
      onPresetItemMouseEnter: onSetPresetTrying,
      onPresetItemMouseLeave: onCancelPresetTrying
    }))));
  });
  func.displayName = "Multiple".concat(pascalCase(panelType)).concat(pascalCase(type));
  return func;
}